import React, { useEffect } from 'react';
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { LogoFontProvider } from './context/LogoFontContext';
import { applyTheme } from './theme';
import NavBar from './components/NavBar';
import ProtectedRoute from './components/ProtectedRoute';

import LoginPage          from './pages/LoginPage';
import RegisterPage       from './pages/RegisterPage';
import WelcomePage        from './pages/WelcomePage';
import DashboardPage      from './pages/DashboardPage';
import FlashcardViewPage  from './pages/FlashcardViewPage';
import FlashcardEditPage  from './pages/FlashcardEditPage';
import QuizModePage       from './pages/QuizModePage';
import QuizReportPage     from './pages/QuizReportPage';
import SharedPlaylistsPage  from './pages/SharedPlaylistsPage';
import PublicPlaylistPage   from './pages/PublicPlaylistPage';
import PublicQuizPage     from './pages/PublicQuizPage';
import PreferencesPage    from './pages/PreferencesPage';
import MarketplacePage    from './pages/MarketplacePage';
import PurchasedDeckPage  from './pages/PurchasedDeckPage';
import PlaylistsPage      from './pages/PlaylistsPage';
import PlaylistEditPage   from './pages/PlaylistEditPage';
import PlaylistReviewPage from './pages/PlaylistReviewPage';
import PlaylistExportPage      from './pages/PlaylistExportPage';
import PlaylistSubmission      from './pages/PlaylistSubmission';

function ThemeWatcher() {
  const { prefs } = useAuth();
  useEffect(() => { applyTheme(prefs.theme ?? 'light'); }, [prefs.theme]);
  return null;
}

function Layout({ children }) {
  return (
    <>
      <NavBar />
      <main className="container pb-5">{children}</main>
    </>
  );
}

function P(props) {
  return (
    <Layout>
      <ProtectedRoute>{props.children}</ProtectedRoute>
    </Layout>
  );
}

export default function App() {
  return (
    <LogoFontProvider>
    <AuthProvider>
      <ThemeWatcher />
      <BrowserRouter>
        <Routes>
          {/* Public */}
          <Route path="/"         element={<Layout><WelcomePage /></Layout>} />
          <Route path="/login"    element={<Layout><LoginPage /></Layout>} />
          <Route path="/register" element={<Layout><RegisterPage /></Layout>} />
          <Route path="/quiz/public/:token"      element={<Layout><PublicQuizPage /></Layout>} />
          <Route path="/playlists/public/:token" element={<Layout><PublicPlaylistPage /></Layout>} />

          {/* Protected */}
          <Route path="/dashboard"       element={<P><DashboardPage /></P>} />
          <Route path="/flashcards/new"  element={<P><FlashcardEditPage /></P>} />
          <Route path="/flashcards/:id"  element={<P><FlashcardViewPage /></P>} />
          <Route path="/flashcards/:id/edit" element={<P><FlashcardEditPage /></P>} />
          <Route path="/quiz"            element={<P><QuizModePage /></P>} />
          <Route path="/report"          element={<P><QuizReportPage /></P>} />
          <Route path="/shared-playlists" element={<P><SharedPlaylistsPage /></P>} />
          <Route path="/marketplace"     element={<P><MarketplacePage /></P>} />
          <Route path="/preferences"        element={<P><PreferencesPage /></P>} />
          <Route path="/purchased-deck/:mpoId" element={<P><PurchasedDeckPage /></P>} />
          <Route path="/playlists"              element={<P><PlaylistsPage /></P>} />
          <Route path="/playlists/new"          element={<P><PlaylistEditPage /></P>} />
          <Route path="/playlists/:id/edit"     element={<P><PlaylistEditPage /></P>} />
          <Route path="/playlists/:id/review"   element={<P><PlaylistReviewPage /></P>} />
          <Route path="/playlists/:id/export"  element={<P><PlaylistExportPage /></P>} />
          <Route path="/playlists/:id/submit"  element={<P><PlaylistSubmission /></P>} />

          {/* Catch-all */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
    </LogoFontProvider>
  );
}
